module.exports = __webpack_public_path__ + "static/media/feature.18395846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/LPC/feature.jpg
// module id = 293
// module chunks = 0